import moji from 'moji'
import {MBMemberError} from '../Common/MBMemberError'

export const convertOnBlur = (name: string, value: string): string => {
  switch (name) {
    case 'familyName':
    case 'firstName':
    case 'addressCity':
    case 'addressStreet':
    case 'addressBuilding':
      return moji(value)
        .convert('HE', 'ZE')
        .convert('HK', 'ZK')
        .convert('HS', 'ZS')
        .trim()
        .toString()
    case 'familyNameKana':
    case 'firstNameKana':
      return moji(value)
        .convert('HK', 'ZK')
        .convert('HG', 'KK')
        .trim()
        .toString()
    case 'postCode':
    case 'phoneMobile':
    case 'phoneTel':
    case 'phone':
    case 'cardNumber':
    case 'securityCode':
      return moji(value)
        .convert('ZE', 'HE')
        .trim()
        .toString()
        .replace(/[^0-9]/g, '')
    default:
      throw new MBMemberError('SystemError')
  }
}
